module.exports = __webpack_public_path__ + "img/natural-sciences.e1f79c27.svg";